import { ColDef } from '@ag-grid-community/core';
import moment from 'moment-timezone';

export const columnDefs: ColDef[] = [
    {
        field: 'title',
        headerName: 'Name',
        suppressHeaderMenuButton: true,
        sortable: false,
        menuTabs: [],
        cellRenderer: 'downloadCellRenderer',
        flex: 1
    },
    {
        field: 'type',
        headerName: 'Type',
        suppressHeaderMenuButton: true,
        sortable: false,
        menuTabs: [],
        flex: 1
    },
    {
        field: 'creationDate',
        headerName: 'Creation Date',
        suppressHeaderMenuButton: true,
        sortable: false,
        menuTabs: [],
        valueFormatter: (params) => moment(params.data.creationDate)
            .format('DD MMM, YYYY'),
        flex: 1
    },
    {
        field: 'description',
        headerName: 'Description',
        suppressHeaderMenuButton: true,
        sortable: false,
        menuTabs: [],
        flex: 1
    }
];